'use strict';

module.exports = function($timeout) {
  var active = false;

  return {
    activate: activate,
    deactivate: deactivate,
    isActive: isActive,
  };

  function activate() {
    active = true;
  }

  function deactivate() {
    $timeout(function() {
      active = false;
    });
  }

  function isActive() {
    return active;
  }
};



// WEBPACK FOOTER //
// ./src/app/modules/calendar/AppointmentDragAndResizeState.js